import { mapGetters } from 'vuex';
import mixinMethods from 'Helpers/mixinMethods';
import utils from 'Helpers/utils';
import store from '~/store';
import BetDialogConfirm from 'Pages/core/betDialog/BetDialogConfirm.vue';
import BetDialogEvent from 'Pages/core/betDialog/BetDialogEvent.vue';
import BetDialogInfo from 'Pages/core/betDialog/BetDialogInfo.vue';
import BetDialogBetInfo from 'Pages/core/betDialog/BetDialogBetInfo.vue';
import { eventBus } from '~/app';
import { v4 as uuidv4 } from 'uuid';

export default {
    name: 'BetDialog',

    components: {
        BetDialogBetInfo,
        BetDialogInfo,
        BetDialogEvent,
        BetDialogConfirm,
    },
    props: {
        id: {
            default: '0',
            type: String,
        },
        beforeCancel: {
            type: Function,
        },
        width: {
            default: 400,
            type: Number,
        },
        contentClass: {
            default: '',
            type: String,
        },
        idPrefix: {
            default: 'bet-dialog-',
            type: String,
        },
        module: undefined,
    },

    data() {
        return {
            zIndex: undefined,
            dialogOpen: false,
            loading: false,
            disabled: true,
            odds: '',
            stake: undefined,
            timeout: 300,
            defaultSuggestedPrices: {
                1: [2, 5, 10, 20, 50, 100], // EURO
                4: [6, 10, 20, 50, 100, 150], // BRL
            },
            isTopUps: false,
            sites: [],
            highlightOdds: [],
            errorMessage: '',
            warningMessage: '',
            order: null,
            orderPlaced: null,
            isOrderPlaced: false,
            isOrderConfirmed: false,
            rules: {
                // timeout: [
                //     (v) => {
                //         // if (utils.isEmpty(v)) {
                //         //     return store.$i18n.t('rules.timeoutRequired');
                //         // }
                //         return true;
                //     },
                // ],
                sites: [
                    (v) => {
                        let validRequired = store.$i18n.t('rules.sitesRequired');
                        let validOdds = false;
                        let self = this;

                        if (Array.isArray(v)) {
                            v.forEach(function (siteId) {
                                if (self.siteOdds[self.id][siteId] && self.siteMinStake(siteId) <= self.stake) {
                                    validRequired = true;
                                    validOdds = true;
                                } else if (self.siteOdds[self.id][siteId]) {
                                    validOdds = true;
                                }
                            });
                        } else if (self.siteOdds[self.id][v]) {
                            validRequired = true;
                            validOdds = true;
                        }

                        return validRequired !== true ? (validOdds === true ? store.$i18n.t('rules.sitesOdds') : validRequired) : validRequired;
                    },
                ],
                stake(module, id, v) {
                    if (utils.isEmpty(v) || v == 0) {
                        return store.$i18n.t('rules.stakeRequired');
                    } else if (!utils.isNumeric(v)) {
                        return store.$i18n.t('rules.integer');
                    } else if (v < 0) {
                        return store.$i18n.t('rules.negative');
                    } else {
                        let minStakes = store.getters['AppModule/getMinStakes'];
                        let allowedSites = store.getters['AppModule/getToolUserSettings'].bet_order_site_ids_allowed;
                        let minArr = [];

                        minStakes = minStakes.bet_order.filter((minStake) => allowedSites.indexOf(minStake[0]) !== -1);

                        minStakes.forEach(function (val) {
                            if (store.getters['UserModule/getUser'].currency === 4 && val[0] === 10) {
                                let betFeedData = store.getters[module + '/getBetFeedData'];
                                let pinnaOdds = betFeedData[id].market.price_list ? betFeedData[id].market.price_list.filter((s) => s[0] === val[0]) : [];

                                if (pinnaOdds[0] && pinnaOdds[0][1] < 1.9) {
                                    minArr.push(Math.floor((5.4 / (pinnaOdds[0][1] - 1) / 70) * 100));
                                    return;
                                }
                            }
                            minArr.push(val[1]);
                        });

                        let minValue = Math.min(...minArr);

                        if (v < minValue) {
                            return store.$i18n.t('rules.minStake', {
                                currency: utils.getCurrencySymbol(store.getters['UserModule/getUser'].currency),
                                value: minValue,
                            });
                        }

                        let maxValue = store.getters['UserModule/getBalance'].credit;

                        if (v > maxValue) {
                            return store.$i18n.t('rules.checkBalance');
                        }

                        return true;
                    }
                },

                odds(module, id, v) {
                    let betSelectionId = store.getters[module + '/getBetFeedData'][id].betSelectionId;

                    if (utils.isEmpty(v)) {
                        return store.$i18n.t('rules.oddsRequired');
                    } else if (parseFloat(v) < 1.1) {
                        return store.$i18n.t('rules.min', { value: 1.1 });
                    } /*else if (
                        betSelectionId !== 5 &&
                        betSelectionId !== 6 &&
                        betSelectionId !== 7 &&
                        parseFloat(v) > 100
                    ) {
                        //not 1x2
                        return store.$i18n.t('betDialog.maxOdds', { value: 100 });
                    }*/
                    return true;
                },
            },
        };
    },

    mounted() {
        console.log('Component %s mounted.', this.$options.name);
    },

    /**
     * we have an issue with v-dialog
     * when we receive updated data z-index is changing to default value
     */
    beforeUpdate() {
        let dialog = document.getElementById(this.idPrefix + this.id);
        if (dialog) {
            this.zIndex = dialog.closest('.v-dialog.v-dialog--active').parentElement.style.zIndex;
        }
    },

    updated() {
        let dialog = document.getElementById(this.idPrefix + this.id);
        if (dialog) {
            dialog.closest('.v-dialog.v-dialog--active').parentElement.style.zIndex = this.zIndex;
        }
    },

    beforeDestroy: function () {
        console.log('Component %s destroyed.', this.$options.name);
    },

    mixins: [mixinMethods],
    methods: {
        normalizePrice(price) {
            if (this.siteOrdered.length > 7 && price.length > 6) {
                price = utils.formatOdds(price, 2);
            }

            return price;
        },
        open(correctPosition = true) {
            this.dialogOpen = true;
            this.isOrderPlaced = false;
            this.isOrderConfirmed = false;
            this.orderPlaced = null;
            let self = this;
            this.highlightOdds = [];

            this.order = null;
            this.stake = '';

            if (this.siteOrdered.length > 0) {
                this.sites = [...this.siteOrdered];
            }

            this.isTopUps = this.toolUserSettings.bet_order_is_top_ups_default;

            if (this.betFeedData[this.id].marketId === this.$const.DBALL_MARKET_LIVE) {
                this.timeout = this.toolUserSettings.bet_order_live_timeout_default;
            } else if (
                this.betFeedData[this.id].marketId === this.$const.DBALL_MARKET_TODAY ||
                this.betFeedData[this.id].marketId === this.$const.DBALL_MARKET_EARLY
            ) {
                this.timeout = this.toolUserSettings.bet_order_dball_timeout_default;
            }

            if (this.toolUserSettings.bet_order_stake_default) {
                this.stake = this.toolUserSettings.bet_order_stake_default;
            }

            let oddsList = this.betFeedData[this.id].isActive === false ? [] : this.betFeedData[this.id].market.price_list;

            if (oddsList && this.stake) {
                oddsList = oddsList.filter(
                    (odds) => self.toolUserSettings.bet_order_site_ids_allowed.indexOf(odds[0]) !== -1 && self.siteMinStake(odds[0]) <= self.stake //skip odds if it is lower than bookmaker minimum
                );
            }

            if (this.toolUserSettings.bet_order_odds_default_type_id === this.$const.DEFAULT_ODDS_TYPE_BEST) {
                if (oddsList.length !== 0) {
                    let maxArr = [];
                    oddsList.forEach((odds) => maxArr.push(odds[1]));

                    this.odds = Math.max(...maxArr);
                }
            } else if (this.toolUserSettings.bet_order_odds_default_type_id === this.$const.DEFAULT_ODDS_TYPE_LOWEST) {
                if (oddsList.length !== 0) {
                    this.odds = Math.floor(oddsList[oddsList.length - 1][1] * 1000) / 1000;
                }
            } else if (this.toolUserSettings.bet_order_odds_default_type_id === this.$const.DEFAULT_ODDS_TYPE_MEDIAN) {
                if (oddsList.length === 1) {
                    this.odds = Math.floor(oddsList[oddsList.length - 1][1] * 1000) / 1000;
                } else if (oddsList.length > 1) {
                    let median = Math.round(oddsList.length / 2);

                    if (oddsList.length % 2 === 0) {
                        let odds1 = oddsList[median - 1][1];
                        let odds2 = oddsList[median][1];

                        this.odds = Math.floor(((odds1 + odds2) / 2) * 1000) / 1000;
                    } else {
                        this.odds = Math.floor(oddsList[median - 1][1] * 1000) / 1000;
                    }
                }
            }

            this.odds = utils.formatOdds(this.odds);

            this.change();

            if (correctPosition) {
                this.$nextTick(() => {
                    let length = Object.keys(this.betFeedData).length;

                    if (length > 0) {
                        let shift = length * 40;
                        let el = document.getElementById(this.getId).parentNode;

                        let left = window.innerWidth / 2 - el.getBoundingClientRect().width + shift - 40;
                        let top = window.innerHeight / 2 - el.getBoundingClientRect().height + shift - 40;

                        el.style.setProperty('position', 'fixed');
                        el.style.setProperty('margin', '0px');
                        el.style.setProperty('left', left + 'px');
                        el.style.setProperty('top', top + 'px');
                    }
                });
            }
        },

        close() {
            this.dialogOpen = false;
            this.$refs.formBetting.reset();

            eventBus.$off('orderAdded');
            eventBus.$off('orderUpdated');
        },

        cancel() {
            this.close();
            let betFeedData = this.betFeedData[this.id];

            this.betFeedData = { idx: this.id, betFeedData: null };

            this.$emit('cancel', {
                betFeedData: betFeedData,
                id: this.id,
            });
        },

        newOrder() {
            // This will reset the order popup to its original format, displaying the current best odds in the odds field,
            // without showing any information from the previously placed order.
            this.open(false);

            eventBus.$off('orderAdded');
            eventBus.$off('orderUpdated');

            this.isOrderPlaced = false;
            this.orderPlaced = null;
        },

        // declineOrder() {
        //     this.$refs.betConfirm.close();
        //     this.loading = false;
        // },

        acceptOrder() {
            this.$refs.betConfirm.close();
            this.isOrderConfirmed = true;
            this.placeOrder(true);
        },

        setRecommendedStake(price) {
            this.stake = price;

            this.change();
        },

        setOdds(odds) {
            if (odds && this.orderPlaced === null) {
                this.odds = odds;
                this.change();
            }
        },

        isLowSiteMinStake(site) {
            return this.siteMinStake(site) > this.stake;
        },

        siteMinStake(site) {
            let minStakes = store.getters['AppModule/getMinStakes'];

            let minStake = minStakes.bet_order.filter((minStake) => minStake[0] === site)[0][1];

            if (this.user.currency === this.$const.CURRENCY_BRL_ID && site === this.$const.SITE_PINNA_ID) {
                if (this.odds < 1.9) {
                    minStake = Math.floor((5.4 / (this.odds - 1) / 70) * 100);
                }
            }

            return minStake;
        },

        focus() {
            let indexHighest = 0;
            let indexHighestEvent = 0;
            Array.from(document.getElementsByClassName('v-dialog__content v-dialog__content--active')).forEach(function (element) {
                // always use a radix when using parseInt
                var index_current = parseInt(element.style.zIndex, 10);

                if (element.children[0].classList.contains('event-dialog') || element.children[0].classList.contains('event-bet-dialog')) {
                    if (index_current > indexHighestEvent) {
                        indexHighestEvent = index_current;
                    }
                } else {
                    if (index_current > indexHighest) {
                        indexHighest = index_current;
                    }
                }
            });

            let dialog = document.getElementById(this.idPrefix + this.id);

            if (dialog.parentElement.classList.contains('event-bet-dialog')) {
                if (this.zIndex < indexHighestEvent) {
                    this.zIndex = indexHighestEvent + 1;

                    dialog.closest('.v-dialog.v-dialog--active').parentElement.style.zIndex = this.zIndex;
                }
            } else {
                if (this.zIndex < indexHighest) {
                    this.zIndex = indexHighest + 1;

                    dialog.closest('.v-dialog.v-dialog--active').parentElement.style.zIndex = this.zIndex;
                }
            }
        },

        change() {
            if (this.user.type !== this.$const.USER_TYPE_PLAYER_ID) {
                this.disabled = true;
                return;
            }
            //check if need to unlock submit button
            this.$nextTick(() => {
                let self = this;
                if (this.$refs.formBetting) {
                    let siteOrdered = this.siteOrdered.filter((site) => self.siteMinStake(site) <= self.stake);
                    if (siteOrdered.length === 0) {
                        this.disabled = true;
                        this.getValidationError();
                    } else if (this.$refs.formBetting.validate()) {
                        this.disabled = false;
                        this.errorMessage = '';
                    } else {
                        this.disabled = true;
                        this.getValidationError();
                    }
                }
            });
        },

        minStakeWarning() {
            if (this.betFeedData[this.id].isActive === false) {
                return false;
            }
            let prices = this.betFeedData[this.id].market.price_list;
            if (prices[0] && this.siteMinStake(prices[0][0]) > this.stake && this.isOrderConfirmed === false) {
                this.warningMessage = store.$i18n.t('betDialog.minOddsWarning', {
                    odds: utils.formatOdds(prices[0][1], 3),
                    currency: utils.getCurrencySymbol(this.user.currency),
                    stake: this.siteMinStake(prices[0][0]),
                });
            } else {
                this.warningMessage = '';
            }

            return true;
        },

        getValidationError() {
            for (const key in this.$refs.formBetting.$el) {
                if (this.$refs.formBetting.inputs[key].errorBucket.length) {
                    this.errorMessage = this.$refs.formBetting.inputs[key].errorBucket[0];
                    return;
                }
            }
        },

        confirmAction() {
            // let self = this;
            // let siteOrdered = this.siteOrdered.filter((site) => self.siteMinStake(site) <= self.stake);
            // if (siteOrdered.length === 0) {
            //     this.disabled = true;
            //     // this.errorMessage = store.$i18n.t('rules.sitesRequired');
            //     // return;
            // }

            if (this.user.type !== this.$const.USER_TYPE_PLAYER_ID) {
                this.disabled = true;
                return;
            }

            if (this.$refs.formBetting.validate()) {
                let self = this;

                let handicap = null;
                let time = null;
                let isLive = this.betFeedData[this.id].marketId == this.$const.DBALL_MARKET_LIVE;
                let score = isLive ? this.betFeedData[this.id].sc : null;
                let corners = isLive ? this.betFeedData[this.id].corners : null;
                let correctScore = this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_CS ? this.betFeedData[this.id].correctScore : null;
                let periodTypeId = this.betFeedData[this.id].periodTypeId;
                let marketId = this.betFeedData[this.id].marketId;

                if (this.betFeedData[this.id].market.handicap) {
                    handicap = this.betFeedData[this.id].market.handicap;

                    if (
                        (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_TEAM_HOME &&
                            this.betFeedData[this.id].market.jw === this.$const.TEAM_HOME) ||
                        (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_TEAM_AWAY &&
                            this.betFeedData[this.id].market.jw === this.$const.TEAM_AWAY) ||
                        (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_CORNERS_TEAM_HOME &&
                            this.betFeedData[this.id].market.jw === this.$const.TEAM_HOME) ||
                        (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_CORNERS_TEAM_AWAY &&
                            this.betFeedData[this.id].market.jw === this.$const.TEAM_AWAY)
                    ) {
                        handicap = -handicap;
                    }
                }

                if (isLive) {
                    time = this.betFeedData[this.id].time;
                }

                let sites = this.sites.filter(function (site) {
                    return !self.isLowSiteMinStake(site);
                });

                //we decided to take version from feed due to we have some problem with version on
                //event popup when some event go to live from today
                //in this case version for live is unknown

                // let version;
                // if (marketId === this.$const.DBALL_MARKET_LIVE) {
                //     version = this.$store.state.FeedLiveModule.version;
                // } else if (marketId === this.$const.DBALL_MARKET_TODAY) {
                //     version = this.$store.getters['FeedDballModule/getTodayVersion'];
                // } else if (marketId === this.$const.DBALL_MARKET_EARLY) {
                //     version = this.$store.getters['FeedDballModule/getEarlyVersion'];
                // }

                let availablePrices = this.betFeedData[this.id].market.price_list.reduce((obj, item) => Object.assign(obj, { [item[0]]: item[1] }), {});

                this.order = {
                    available_prices: JSON.stringify(availablePrices),
                    custom_event_id: this.betFeedData[this.id].ceId,
                    date_game: this.betFeedData[this.id].dateGame,
                    custom_league_id: this.betFeedData[this.id].clId,
                    custom_team_home_id: this.betFeedData[this.id].cthId,
                    custom_team_away_id: this.betFeedData[this.id].ctaId,
                    bet_type_id: this.betFeedData[this.id].betTypeId,
                    bet_selection_id: this.betFeedData[this.id].betSelectionId,
                    period_type_id: periodTypeId,
                    is_top_ups: this.isTopUps,
                    site_ids: sites.sort(this.compareNumbers).join(),
                    score: score,
                    correct_score: correctScore, //for Correct Score market
                    corners: corners,
                    handicap: handicap,
                    time: time,
                    is_live: isLive,
                    market_id: marketId,
                    odds: this.odds,
                    stake: this.stake,
                    timeout: this.timeout,
                    jollywhere: this.betFeedData[this.id].market.jw,
                    uuid: uuidv4(),
                    // version: version,
                };

                if (this.toolUserSettings.bet_order_is_request_bet_confirmation_default) {
                    this.$refs.betConfirm.open();
                } else {
                    this.isOrderConfirmed = true;
                    this.placeOrder();
                }
            } else {
                this.disabled = true;

                for (const key in this.$refs.formBetting.$el) {
                    if (this.$refs.formBetting.inputs[key].errorBucket.length) {
                        this.errorMessage = this.$refs.formBetting.inputs[key].errorBucket[0];
                        return;
                    }
                }
            }
            // });
        },

        placeOrder(isNoScoreAndTimeAccepted = false) {
            let self = this;
            this.loading = true;

            if (this.order.is_live && isNoScoreAndTimeAccepted) {
                this.order.is_no_score_and_time_accepted = true;
            }

            const uuid = this.order.uuid;

            self.orderPlaced = {
                uuid: uuid,
            };

            //for slow connection possible issue when we receive event orderAdded before success response order placed
            //in this case we have to fill orderPlaced with full dataset
            eventBus.$on('orderAdded', (data) => {
                if (data.uuid === self.orderPlaced.uuid) {
                    data.stats = {};
                    self.orderPlaced = data;
                }
            });

            eventBus.$on('orderUpdated', (data) => {
                if (data.id === self.orderPlaced.id) {
                    const order = {};
                    if (data.status_id) {
                        order.status_id = data.status_id;
                    }

                    if (data.close_reason_id) {
                        order.close_reason_id = data.close_reason_id;
                    }

                    if (data.stats) {
                        order.stats = data.stats;
                    }

                    self.orderPlaced = Object.assign({}, self.orderPlaced, order);
                }
            });

            this.$store.dispatch('OrderModule/placeOrder', { rows: [this.order] }).then(function (response) {
                self.loading = false;

                if (response.data.success) {
                    self.errorMessage = '';
                    self.$refs.formBetting.resetValidation();

                    if (!self.toolUserSettings.bet_order_is_keep_order_popup_open_default) {
                        self.cancel();
                    } else {
                        self.isOrderPlaced = true;
                        let data = response.data.row;
                        data.stats = {};

                        //we need to update orderPlaced only if it was not filled in orderAdded event
                        //due to slow connection we can get orderAdded event before response for this request
                        if (self.orderPlaced.id === undefined) {
                            self.orderPlaced = data;
                        }
                    }
                } else {
                    let message;
                    try {
                        message = JSON.parse(response.data.message);
                        for (let key in message[1]) {
                            message[1][key] = self.$te(message[1][key]) ? self.$t(message[1][key]) : message[1][key];
                        }
                    } catch (e) {
                        message = response.data.message;
                    }

                    self.errorMessage = Array.isArray(message) ? self.$t(message[0], message[1]) : self.$t(message);
                }
            });
        },

        compareNumbers(a, b) {
            return a - b;
        },

        getPrevOdds: function (item, siteId, hdp, oddsMaxKey) {
            let key = siteId + '_' + oddsMaxKey + '_' + hdp;

            return this.highlightOdds[key] ? this.highlightOdds[key] : false;
        },

        setPrevOdds: function (item, siteId, hdp, oddsMaxKey, highlightClass, highlightClassIndex) {
            let key = siteId + '_' + oddsMaxKey + '_' + hdp;

            let price = this.getPriceForHighlight(item, siteId, oddsMaxKey);

            this.highlightOdds[key] = {
                price: price,
                highlightClass: highlightClass,
                highlightClassIndex: highlightClassIndex,
            };
        },

        getPriceForHighlight: function (item, siteId, oddsMaxKey) {
            let price = this.siteOdds[this.id][siteId];
            if (oddsMaxKey.includes('extra')) {
                let extraOddsIdx = oddsMaxKey.split('_')[1];
                price = Object.entries(this.betFeedData[this.id].extraOdds[siteId])[extraOddsIdx][0];
            }

            return price;
        },

        getHighlightClass: function (item, siteId, hdp, oddsMaxKey) {
            let prevOdds = this.getPrevOdds(item, siteId, hdp, oddsMaxKey);

            /*need classes with indexes 1 and 2, we switch classes when prices change continuously*/
            if (prevOdds) {
                let price = this.getPriceForHighlight(item, siteId, oddsMaxKey);
                if (price === prevOdds['price']) {
                    return prevOdds.highlightClass;
                } else if (price > prevOdds['price']) {
                    let hlClassIndex = prevOdds['highlightClassIndex'] === 1 ? 2 : 1;
                    this.setPrevOdds(item, siteId, hdp, oddsMaxKey, 'highlightGreen' + hlClassIndex, hlClassIndex);
                    return 'highlightGreen' + hlClassIndex;
                } else {
                    let hlClassIndex = prevOdds['highlightClassIndex'] === 1 ? 2 : 1;
                    this.setPrevOdds(item, siteId, hdp, oddsMaxKey, 'highlightGreen' + hlClassIndex, hlClassIndex);
                    return 'highlightRed' + hlClassIndex;
                }
            }

            this.setPrevOdds(item, siteId, hdp, oddsMaxKey, '', 1);

            return '';
        },

        getSite(siteId) {
            let sites = this.getOrderSiteDictionary;
            let result = sites.filter((site) => site.id === siteId);

            return result[0] ? result[0] : null;
        },

        showChangeOrderSettingsDialog() {
            if (this.$parent.$parent.$parent.$parent.$refs.changeOrderSettingsDialog) {
                this.$parent.$parent.$parent.$parent.$refs.changeOrderSettingsDialog.open();
            } else if (this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$refs.changeOrderSettingsDialog) {
                this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$refs.changeOrderSettingsDialog.open();
            }
        },
    },

    computed: {
        ...mapGetters({
            getBetStatusDictionary: 'DictionariesModule/getBetStatusDictionary',
            getBotBetTypeDictionary: 'DictionariesModule/getBotBetTypeDictionary',
            getSiteDictionary: 'DictionariesModule/getSiteDictionary',
            getOrderSiteDictionary: 'DictionariesModule/getOrderSiteDictionary',
        }),

        getTimeoutDictionary() {
            return this.betFeedData[this.id].marketId === this.$const.DBALL_MARKET_LIVE
                ? this.$store.getters['DictionariesModule/getTimeoutLiveDictionary']
                : this.$store.getters['DictionariesModule/getTimeoutDballDictionary'];
        },

        suggestedPrices() {
            return this.toolUserSettings.bet_order_suggested_prices_default
                ? this.toolUserSettings.bet_order_suggested_prices_default
                : this.defaultSuggestedPrices[this.user.currency];
        },

        siteOrdered() {
            let order = [
                this.$const.SITE_PINNA_ID,
                this.$const.SITE_BETFAIR_ID,
                this.$const.SITE_MATCHBOOK_ID,
                this.$const.SITE_ISN_ID,
                this.$const.SITE_3BET_ID,
                this.$const.SITE_SHARPBET_ID,
                this.$const.SITE_IBC_ID,
                this.$const.SITE_SBO_ID,
            ];
            let self = this;

            let arr = _.sortBy(this.toolUserSettings.bet_order_site_ids_allowed, function (id) {
                return _.indexOf(order, id);
            });

            return arr.filter((siteId) => self.getSite(siteId) !== null);
        },

        toolUserSettings: {
            get() {
                return this.$store.getters['AppModule/getToolUserSettings'];
            },
            set(value) {
                this.$store.commit('AppModule/setToolUserSettings', value);
            },
        },

        betFeedData: {
            get() {
                return this.$store.getters[this.module + '/getBetFeedData'];
            },
            set(value) {
                this.$store.commit(this.module + '/setBetFeedData', value);
            },
        },

        siteOdds() {
            let siteOdds = [this.id];
            siteOdds[this.id] = [];

            let self = this;
            if (this.betFeedData[this.id].market.price_list) {
                this.betFeedData[this.id].market.price_list.forEach(function (site) {
                    var idx = '2' in site ? 2 : 1; //TODO Remove after release
                    // siteOdds[self.id].push(site[0]);
                    siteOdds[self.id][site[0]] = utils.formatOdds(site[idx]);
                });
            }

            return siteOdds;
        },

        getWidth() {
            if (this.$props.width) {
                return this.$props.width;
            }

            return 400;
        },

        getId() {
            return this.idPrefix + this.id;
        },

        user() {
            return this.$store.getters['UserModule/getUser'];
        },

        returns() {
            if (this.stake && this.odds) {
                return (this.stake * this.odds).toFixed(2);
            }

            return '';
        },

        stakeButtonStyle() {
            let width = '55px';
            if (this.siteOrdered.length > 5) {
                width = 100 / this.siteOrdered.length + '%';
            }
            return 'width: ' + width;
        },

        bestOdds() {
            let bestOdds = this.betFeedData[this.id].market.price_max;
            return utils.formatOdds(bestOdds);
        },

        bestMaxStake() {
            let bestMaxStake = 0;

            // let bestOddsSiteKey = this.betFeedData[this.id].oddsMaxKey + 'S'; //hdK1mS etc
            let bestOddsSiteId = this.betFeedData[this.id].market.price_max_site_id;

            if (this.betFeedData[this.id].oddsMaxStake && this.betFeedData[this.id].oddsMaxStake[bestOddsSiteId]) {
                bestMaxStake = this.betFeedData[this.id].oddsMaxStake[bestOddsSiteId];
            }

            return bestMaxStake;
        },

        availableMaxStake() {
            if (this.betFeedData[this.id].oddsMaxStake) {
                let self = this;
                let availableMaxStake = 0;
                this.siteOdds[this.id].forEach(function (siteOdds, siteId) {
                    if (parseFloat(siteOdds) >= parseFloat(self.odds)) {
                        availableMaxStake += self.betFeedData[self.id].oddsMaxStake[siteId] ?? 0;
                    }
                    if (self.betFeedData[self.id].extraOdds && self.betFeedData[self.id].extraOdds[siteId]) {
                        Object.entries(self.betFeedData[self.id].extraOdds[siteId]).forEach(([odds, val]) => {
                            if (parseFloat(odds) >= parseFloat(self.odds)) {
                                availableMaxStake += val;
                            }
                        });
                    }
                });

                return availableMaxStake;
            }
        },

        medianOdds() {
            let oddsList = this.betFeedData[this.id].isActive === false ? [] : this.betFeedData[this.id].market.price_list;
            let medianOdds;

            if (!oddsList) {
                return medianOdds;
            }

            if (oddsList && this.stake) {
                oddsList = oddsList.filter(
                    (odds) => this.toolUserSettings.bet_order_site_ids_allowed.indexOf(odds[0]) !== -1 && this.siteMinStake(odds[0]) <= this.stake //skip odds if it is lower than bookmaker minimum
                );
            }
            if (oddsList.length === 1) {
                medianOdds = Math.floor(oddsList[oddsList.length - 1][1] * 1000) / 1000;
            } else if (oddsList.length > 1) {
                let median = Math.round(oddsList.length / 2);

                if (oddsList.length % 2 === 0) {
                    let odds1 = oddsList[median - 1][1];
                    let odds2 = oddsList[median][1];

                    medianOdds = Math.floor(((odds1 + odds2) / 2) * 1000) / 1000;
                } else {
                    medianOdds = Math.floor(oddsList[median - 1][1] * 1000) / 1000;
                }
            }

            return utils.formatOdds(medianOdds);
        },

        medianMaxStake() {
            if (this.betFeedData[this.id].oddsMaxStake) {
                let self = this;
                let medianMaxStake = 0;

                this.siteOdds[this.id].forEach(function (siteOdds, siteId) {
                    if (parseFloat(siteOdds) >= parseFloat(self.medianOdds)) {
                        medianMaxStake += self.betFeedData[self.id].oddsMaxStake[siteId] ?? 0;
                    }
                    if (self.betFeedData[self.id].extraOdds && self.betFeedData[self.id].extraOdds[siteId]) {
                        Object.entries(self.betFeedData[self.id].extraOdds[siteId]).forEach(([odds, val]) => {
                            if (parseFloat(odds) >= parseFloat(self.medianOdds)) {
                                medianMaxStake += val;
                            }
                        });
                    }
                });

                return medianMaxStake;
            }
        },

        totalOdds() {
            let worstOdds;
            this.siteOdds[this.id].forEach(function (siteOdds) {
                if (!worstOdds || worstOdds > parseFloat(siteOdds)) {
                    worstOdds = parseFloat(siteOdds);
                }
            });
            return utils.formatOdds(worstOdds);
        },

        totalMaxStake() {
            if (this.betFeedData[this.id].oddsMaxStake) {
                let self = this;
                let totalMaxStake = 0;
                this.siteOdds[this.id].forEach(function (siteOdds, siteId) {
                    totalMaxStake += self.betFeedData[self.id].oddsMaxStake[siteId] ?? 0;

                    if (self.betFeedData[self.id].extraOdds && self.betFeedData[self.id].extraOdds[siteId]) {
                        Object.entries(self.betFeedData[self.id].extraOdds[siteId]).forEach(([odds, val]) => {
                            totalMaxStake += val;
                        });
                    }
                });

                return totalMaxStake;
            }
        },
    },
};
(function () {
    // make vuetify dialogs movable
    const d = {};

    var index_highest = 0;
    var index_highest_event = 0;

    var unFocus = function () {
        if (document.selection) {
            document.selection.empty();
        } else {
            window.getSelection().removeAllRanges();
        }
    };

    document.addEventListener('mousedown', (e) => {
        unFocus();
        const closestDialog = e.target.closest('.v-dialog.v-dialog--active');
        if (
            e.button === 0 &&
            closestDialog != null &&
            (e.target.classList.contains('popup-header') || e.target.parentElement.classList.contains('popup-header'))
        ) {
            // element which can be used to move element
            Array.from(document.getElementsByClassName('v-dialog__content v-dialog__content--active')).forEach(function (element) {
                // always use a radix when using parseInt
                var index_current = parseInt(element.style.zIndex, 10);
                if (element.children[0].classList.contains('event-bet-dialog')) {
                    if (index_current > index_highest_event) {
                        index_highest_event = index_current;
                    }
                } else {
                    if (index_current > index_highest) {
                        index_highest = index_current;
                    }
                }
            });

            d.el = closestDialog; // element which should be moved

            if (d.el.classList.contains('event-bet-dialog')) {
                if (d.el.parentElement.style.zIndex < index_highest_event) {
                    d.el.parentElement.style.zIndex = index_highest_event + 1;
                }
            } else {
                if (d.el.parentElement.style.zIndex < index_highest) {
                    d.el.parentElement.style.zIndex = index_highest + 1;
                }
            }

            d.mouseStartX = e.clientX;
            d.mouseStartY = e.clientY;
            d.elStartX = d.el.getBoundingClientRect().left;
            d.elStartY = d.el.getBoundingClientRect().top;
            d.el.style.position = 'fixed';
            d.el.style.margin = 0;
            d.oldTransition = d.el.style.transition;
            d.el.style.transition = 'none';
        }
    });

    document.addEventListener('touchstart', (e) => {
        const closestDialog = e.target.closest('.v-dialog.v-dialog--active');
        if (closestDialog != null && (e.target.classList.contains('popup-header') || e.target.parentElement.classList.contains('popup-header'))) {
            // element which can be used to move element
            Array.from(document.getElementsByClassName('v-dialog__content v-dialog__content--active')).forEach(function (element) {
                // always use a radix when using parseInt
                var index_current = parseInt(element.style.zIndex, 10);
                if (element.children[0].classList.contains('event-bet-dialog')) {
                    if (index_current > index_highest_event) {
                        index_highest_event = index_current;
                    }
                } else {
                    if (index_current > index_highest) {
                        index_highest = index_current;
                    }
                }
            });

            d.el = closestDialog; // element which should be moved

            if (d.el.classList.contains('event-bet-dialog')) {
                if (d.el.parentElement.style.zIndex < index_highest_event) {
                    d.el.parentElement.style.zIndex = index_highest_event + 1;
                }
            } else {
                if (d.el.parentElement.style.zIndex < index_highest) {
                    d.el.parentElement.style.zIndex = index_highest + 1;
                }
            }

            d.mouseStartX = e.changedTouches[0].clientX;
            d.mouseStartY = e.changedTouches[0].clientY;
            d.elStartX = d.el.getBoundingClientRect().left;
            d.elStartY = d.el.getBoundingClientRect().top;
            d.el.style.position = 'fixed';
            d.el.style.margin = 0;
            d.oldTransition = d.el.style.transition;
            d.el.style.transition = 'none';
        }
    });

    document.addEventListener('mousemove', (e) => {
        if (d.el === undefined) return;

        unFocus();

        d.el.style.left = Math.min(Math.max(d.elStartX + e.clientX - d.mouseStartX, 0), window.innerWidth - d.el.getBoundingClientRect().width) + 'px';
        d.el.style.top = Math.min(Math.max(d.elStartY + e.clientY - d.mouseStartY, 0), window.innerHeight - d.el.getBoundingClientRect().height) + 'px';
    });

    document.addEventListener('touchmove', function (e) {
        if (d.el === undefined) return;

        d.el.style.left =
            Math.min(Math.max(d.elStartX + e.changedTouches[0].clientX - d.mouseStartX, 0), window.innerWidth - d.el.getBoundingClientRect().width) + 'px';
        d.el.style.top =
            Math.min(Math.max(d.elStartY + e.changedTouches[0].clientY - d.mouseStartY, 0), window.innerHeight - d.el.getBoundingClientRect().height) + 'px';
    });

    document.addEventListener('mouseup', () => {
        if (d.el === undefined) return;
        d.el.style.transition = d.oldTransition;
        d.el = undefined;
    });

    document.addEventListener('touchend', () => {
        if (d.el === undefined) return;
        d.el.style.transition = d.oldTransition;
        d.el = undefined;
    });
    //     setInterval(() => {
    //         // prevent out of bounds
    //         const dialog = document.querySelector('.v-dialog.v-dialog--active');
    //         if (dialog === null) return;
    //         dialog.style.left =
    //             Math.min(parseInt(dialog.style.left), window.innerWidth - dialog.getBoundingClientRect().width) + 'px';
    //         dialog.style.top =
    //             Math.min(parseInt(dialog.style.top), window.innerHeight - dialog.getBoundingClientRect().height) + 'px';
    //     }, 1000);
})();
